/**
 * en-GB messages added by shared reception security-fix task SECSR1 (security review of 26 Oct 2026).
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const secSr1EnGB = {
    // Refusals
    'error.sr_link_pending_approval': 'This company has not approved this tablet yet.',
    'error.sr_tablet_limit': 'This building already has the most tablets it is allowed. Remove a tablet or ask the platform administrator to raise the limit.',
    // Email: a new shared tablet asks to be linked to the company
    'email.shared-reception.new_tablet.subject': 'A new shared tablet at {building} is waiting for your approval',
    'email.shared-reception.new_tablet.body': 'A new tablet, "{device}", asked at {time} to sign visitors in for {tenant} at the shared reception at {building}. It cannot do so until you approve it. If you do not recognise it, deny it.',
    'email.shared-reception.new_tablet.button': 'Review the tablet',
    // Email: a building evacuation has been running a long time
    'email.shared-reception.evacuation_long.subject': 'The {kind} at {building} is still running',
    'email.shared-reception.evacuation_long.body': 'The {kind} at {building} began at {since} and has not been ended. If it is over, end it in the building area. It will be ended automatically after the building’s limit.',
    'email.shared-reception.evacuation_long.button': 'Open the building area',
    'sr.evac.kind.real': 'evacuation',
    'sr.evac.kind.drill': 'practice drill',
    'sr.evac.auto_end_label': 'Ended automatically',
    // Data protection overview
    'dp.retention.sr_roll_call_drill': 'Names on the shared building roll call from a practice drill are deleted this many days after the drill ends.',
    // Company page: tablets waiting for approval
    'srt.pending.title': 'New shared tablets waiting for your approval',
    'srt.pending.description': 'A tablet in a shared building has asked to sign visitors in for your company. Nothing is shared with it until you approve it. If you do not recognise a tablet, deny it.',
    'srt.pending.item': '{device} at {building}',
    'srt.pending.requested': 'Asked on {time}',
    'srt.pending.approve': 'Approve',
    'srt.pending.deny': 'Deny',
    'srt.pending.deny.confirm': 'Yes, deny it',
    'srt.pending.approved': 'Tablet approved.',
    'srt.pending.denied': 'Tablet denied.',
    'srt.pending.viewOnly': 'You can see these tablets, but only someone who manages shared reception can approve or deny them.',
    // Devices pages
    'srt.devices.waiting': 'Waiting for your approval',
    'sr.building.devices.waiting': 'Waiting for the company’s approval',
    // Building area: evacuation page
    'sr.evac.signedOut': 'Signed out — sign in again',
    'sr.evac.signedOut.detail': 'The list below is the last one this screen received. It is no longer updating.',
    'sr.evac.signedOut.button': 'Sign in again',
    // Building settings: evacuation limits
    'srb.settings.autoEndReal': 'End a real evacuation automatically after (hours)',
    'srb.settings.autoEndDrill': 'End a practice drill automatically after (hours)',
    'srb.settings.autoEndHint': 'If nobody ends it. 0 = never.',
    'srb.settings.longRunning': 'Email the alert address when an evacuation has run for (hours)',
    'srb.settings.longRunningHint': 'Sent once. 0 = off.',
    // Company setting
    'settings.shared-reception.approveNewSharedTablets': 'Ask me before a new shared tablet is linked to my company',
    // Platform settings labels
    'settings.shared-reception.drillRetentionDays': 'Delete names from a practice drill list after this many days (0 = when it ends)',
    'settings.shared-reception.maxTabletsPerBuilding': 'Most tablets one building may have (0 = no limit)',
    'settings.shared-reception.linkReissueMinutes': 'A tablet that lost its first company token may ask again for this many minutes',
    'settings.shared-reception.maxEvacuationBackdateHours': 'Move an evacuation start time older than this many hours back to the limit (0 = no limit)',
    'settings.shared-reception.marshalPhoneRetentionDays': 'Delete revoked or expired marshal phones after this many days (0 = keep)',
    'settings.shared-reception.minCompaniesForTotals': 'Show building totals to a company only when the building has at least this many companies',
};
//# sourceMappingURL=secsr1.js.map